"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../../../../../..");
const IntersectionObserver_1 = require("../../../IntersectionObserver");
const Thread_styles_1 = require("../../../Thread.styles");
const Thread_utils_1 = require("../../../Thread.utils");
const ThreadContext_1 = require("../../../ThreadContext");
const Message_styles_1 = require("./Message.styles");
const Attachment_1 = require("./attachment/Attachment");
const Tooltip_1 = require("../../../../../Tooltip");
const Ellipsis = ({ children }) => {
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    const toggleEllipses = () => setExpanded((prev) => !prev);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.Button, { icon: {
                name: "More",
                colour: "night",
                style: "Fill",
                title: expanded ? "Hide" : "Show more",
            }, dimension: "small", theme: "secondary", onClick: toggleEllipses }),
        expanded && react_1.default.createElement(__1.Text, null, children)));
};
const ButtonWithFeedback = (props) => {
    const [feedback, setFeedback] = (0, react_1.useState)(undefined);
    if ("customElement" in props) {
        return react_1.default.createElement(react_1.default.Fragment, null, props.customElement);
    }
    const { providesFeedback, onClick } = props, restProps = __rest(props, ["providesFeedback", "onClick"]);
    if (!providesFeedback) {
        return react_1.default.createElement(__1.Button, Object.assign({ theme: "secondary", onClick: onClick }, restProps));
    }
    const wrappedOnClick = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const feedback = yield onClick(event);
        setFeedback(feedback);
    });
    return (react_1.default.createElement(Tooltip_1.TooltipProvider, null,
        react_1.default.createElement(__1.Tooltip, { open: feedback !== undefined },
            react_1.default.createElement(__1.TooltipTrigger, { asChild: true, onBlur: () => setFeedback(undefined) },
                react_1.default.createElement(__1.Button, Object.assign({ theme: "secondary", onClick: wrappedOnClick }, restProps))),
            feedback && (react_1.default.createElement(__1.TooltipContent, { side: "top", align: "center" },
                react_1.default.createElement(__1.Text, { skinny: true }, feedback.text))))));
};
/**
    Outputs the message with an icon next to it

    The format of the message is decided by the inboxType value
    - if the inboxType === "information", the only thing the component needs is some children, in form of string or JSX.
    - if the inboxType === "sent" | "received", other props will be required, such as sender name, date sent, etc.

    Note: for all inbox message types, it is possible to optionally monitor read status of a message
*/
const Message = (_a) => {
    var _b, _c, _d, _e, _f;
    var { children } = _a, props = __rest(_a, ["children"]);
    const { trackedMessageRefs } = (0, ThreadContext_1.useThread)();
    const wasReadWhenMounted = (0, react_1.useMemo)(() => props.inboxType === "sent" && !!props.dateRead, []);
    const { readActionProps, inboxType } = props;
    const renderTrackedMessageEdge = (edge) => {
        if (!readActionProps) {
            return null;
        }
        const { id, onMessageSeen } = readActionProps;
        return (react_1.default.createElement("span", { ref: (el) => (0, Thread_utils_1.assignRef)(trackedMessageRefs.current, el, edge, id, onMessageSeen), "data-testid": `${edge}-${id}`, "data-itemid": id, "data-edge": edge, role: "presentation" }));
    };
    /**
     * this function returns a string to use as a className
     * for the message status. This can be used to hook into
     * or identify the element for external services
     * e.g webflow.
     * @returns string the className for the status element
     */
    const getStatusClassName = () => {
        if (props.inboxType !== "sent")
            return "";
        if (props.failed)
            return "message-failed-indicator";
        if (props.dateRead)
            return "message-read-indicator";
        if (props.delivered)
            return "message-delivered-indicator";
        if (props.sent)
            return "message-sent-indicator";
        if (props.inProgressMessage)
            return "message-sending-indicator";
        return "";
    };
    function getStatusIcon() {
        if (props.inboxType !== "sent")
            return null;
        /* Over here we are checking the different delivery states of a message,
        the statuses have a priority over each other which we see in the order of the if statements
        1. failed
        2. Read
        3. Delivered
        4. Set
        5. Sending / In progress
        the statuses also have classnames to allow hooking into them with external tools e.g Userflow
        */
        if (props.failed)
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.Icon, { props: { "data-testid": "failed-icon" }, name: "Failed", style: "Fill", colour: "red", size: 3 }),
                react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true }, "Failed \u00B7")));
        else if (props.dateRead) {
            return (react_1.default.createElement(Thread_styles_1.StyledReadIconContainer, { animate: !wasReadWhenMounted, title: `Read: ${props.dateRead}`, orientation: "horizontal", horizontalContentAlignment: "right", verticalContentAlignment: "center", gutter: 0.5 },
                react_1.default.createElement(__1.Icon, { props: { "data-testid": "read-icon" }, name: "TickDouble", style: "Line", colour: "green", size: 3 }),
                react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true }, "Read \u00B7")));
        }
        else if (props.delivered) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.Icon, { props: { "data-testid": "delivered-icon" }, name: "TickDouble", style: "Line", colour: "stone", size: 3 }),
                react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true }, "Delivered \u00B7")));
        }
        else if (props.sent) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(__1.Icon, { props: { "data-testid": "sent-icon" }, name: "Tick", style: "Line", colour: "stone", size: 3 }),
                react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true }, "Sent \u00B7")));
        }
        else if (props.inProgressMessage) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Message_styles_1.StyledSpinner, { placement: "inline", dimension: "extra-small" }),
                react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true },
                    props.inProgressMessage,
                    " \u00B7")));
        }
        return null;
    }
    if (props.inboxType === "information") {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderTrackedMessageEdge(IntersectionObserver_1.Edge.top),
            react_1.default.createElement(Thread_styles_1.StyledInformationMessageBody, { "data-testid": "thread-message-information" }, typeof children === "string" ? (react_1.default.createElement(__1.Text, { colour: "metal", variant: "body" }, children)) : (children)),
            renderTrackedMessageEdge(IntersectionObserver_1.Edge.bottom)));
    }
    const { dateCreated, senderFullName, attachments = [], actionButtons = [], outerActionButtons = [], } = props;
    const avatarColour = (0, react_1.useMemo)(() => {
        if (inboxType === "received") {
            return "grey";
        }
        else {
            return "blue";
        }
    }, [inboxType]);
    return (react_1.default.createElement(Thread_styles_1.StyledMessageFlexContainer, { "data-testid": "thread-message", inboxType: inboxType, hasFailed: props.inboxType === "sent" && props.failed },
        react_1.default.createElement(Thread_styles_1.StyledMessageContainer, null,
            react_1.default.createElement(Thread_styles_1.StyledMessageBubble, null,
                renderTrackedMessageEdge(IntersectionObserver_1.Edge.top),
                react_1.default.createElement(Message_styles_1.StyledMessageHeader, null,
                    react_1.default.createElement(Thread_styles_1.StyledAvatarAndName, null,
                        !props.displayTextHeaderOnly && (react_1.default.createElement(Thread_styles_1.StyledAvatarWrapper, null,
                            react_1.default.createElement(__1.Avatar, { colour: avatarColour, name: (_b = senderFullName === null || senderFullName === void 0 ? void 0 : senderFullName.name) === null || _b === void 0 ? void 0 : _b.fullName, size: "medium" }))),
                        senderFullName !== null && (react_1.default.createElement(Thread_styles_1.StyledDisplayName, null,
                            ((_c = senderFullName === null || senderFullName === void 0 ? void 0 : senderFullName.name) === null || _c === void 0 ? void 0 : _c.shouldDisplayFullName) && (react_1.default.createElement(Thread_styles_1.StyledSenderName, null,
                                react_1.default.createElement(__1.Text, { variant: "label", as: (_d = senderFullName.headingLevel) !== null && _d !== void 0 ? _d : "h2", skinny: true }, senderFullName.name.fullName))),
                            senderFullName.label && (react_1.default.createElement(__1.Text, { variant: "label", as: (_e = senderFullName.headingLevel) !== null && _e !== void 0 ? _e : "h2", skinny: true }, senderFullName.label))))),
                    actionButtons.length > 0 && (react_1.default.createElement(Thread_styles_1.StyledActionButtonContainer, null, actionButtons.map((props) => {
                        const key = "id" in props ? props.id : props.text;
                        return (react_1.default.createElement(ButtonWithFeedback, Object.assign({ key: key }, props)));
                    })))),
                props.displayTextHeaderOnly && react_1.default.createElement(Thread_styles_1.StyledHr, null),
                react_1.default.createElement(Thread_styles_1.StyledMessageBody, null,
                    typeof children === "string" ? (react_1.default.createElement(__1.Text, null, children)) : (children),
                    props.hiddenMessagePart && (react_1.default.createElement(Ellipsis, null, props.hiddenMessagePart))),
                attachments.length > 0 && (react_1.default.createElement(Message_styles_1.StyledAttachmentContainer, { gutter: 1 }, attachments.map((a, i) => "customElement" in a ? (react_1.default.createElement(react_1.Fragment, { key: a.id }, a.customElement)) : (react_1.default.createElement(Attachment_1.Attachment, Object.assign({}, a, { key: `${a.downloadUrl || a.previewUrl}-${i}` })))))),
                react_1.default.createElement(__1.StackPanel, { orientation: "horizontal", horizontalContentAlignment: "left", verticalContentAlignment: "center", gutter: 0.5 }, (_f = props.badges) === null || _f === void 0 ? void 0 : _f.map((badge, ix) => (react_1.default.createElement(__1.Badge, Object.assign({ className: "text-nowrap", key: ix }, badge))))),
                react_1.default.createElement(Message_styles_1.StyledMessageInfoContainer, null,
                    react_1.default.createElement("div", null, props.deliveryMethod && (react_1.default.createElement(__1.Text, { colour: "metal", variant: "preview", skinny: true },
                        "Via: ",
                        react_1.default.createElement(Message_styles_1.StyledUnderlinedText, null, props.deliveryMethod)))),
                    react_1.default.createElement(__1.StackPanel, { orientation: "horizontal", horizontalContentAlignment: "right", verticalContentAlignment: "center", gutter: 0.5, className: getStatusClassName() },
                        getStatusIcon(),
                        react_1.default.createElement(__1.Text, { variant: "preview", colour: "metal", skinny: true }, dateCreated))),
                renderTrackedMessageEdge(IntersectionObserver_1.Edge.bottom)),
            outerActionButtons.length > 0 && (react_1.default.createElement(Thread_styles_1.StyledOuterActionButtonContainer, null, outerActionButtons.map((props) => (react_1.default.createElement(ButtonWithFeedback, Object.assign({ key: props.text }, props)))))))));
};
exports.Message = Message;
//# sourceMappingURL=Message.js.map